module.exports = __webpack_public_path__ + "static/media/cochrane.36cadfe9.png";